import { dayjs } from "@saas/core";

export type FormatQueryDateInput = string | Date;

export type FormatQueryDateOutput = string | undefined;

export const formatQueryDate = (
  input?: FormatQueryDateInput
): FormatQueryDateOutput => {
  if (!input || input.toString() === "Invalid Date") return undefined;

  return dayjs(input).format("YYYY-MM-DD");
};

export default formatQueryDate;
